module.exports = __webpack_public_path__ + "img/sadad.7e9a3893.png";